export default __webpack_public_path__ + "static/media/landing-write-email.417e23d4.svg";